module.exports = __webpack_public_path__ + "images/emoji/pill.c92d19c4c9b81ee75be1.png";